import * as Yup from "yup"

export const getValidationSchema = () =>
  Yup.object().shape({
    supportType: Yup.string().required(),
    supportNumber: Yup.number().required('Campul este obligatoriu.').min(1, 'Cantitatea trebuie să fie mai mare ca zero!'),
    currentSupportTypeId: Yup.string()
  })

export const initialValues = {
  supportType: "",
  supportNumber: "",
  currentSupportTypeId: ""
}
